/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useState } from 'react';

import { Button, Checkbox, Form, message, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import '../style.scss';

import NightOwlLogo from 'assets/svgs/NightOwl-Logo-Black.svg';
import ErrorFallback from 'components/error-fallback';
import usePostTermsOfUse from 'middleware/hcp/termsOfUse/usePostTermsOfUse';

import TermsOfUseSupport from '../not-accept';
import PDFViewer from '../pdfView';

const TermsOfUseIntegrators = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [notAccept, setNotAccept] = useState(false);
  const ToUAccepted = sessionStorage.getItem('IntgratorsTerms') ?? '';

  // eslint-disable-next-line compat/compat
  const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
  const data = {
    versionReadByPortalUser: urlParams.get('versionReadByPortalUser') || '',
    s3Url: urlParams.get('s3url') || '',
    versionId: urlParams.get('versionId') || '',
    type: urlParams.get('type') || urlParams.get('s3url')?.split('/')?.[3] || '',
  };
  const authType = data?.type === 'nightowl-partner' ? 'nonce' : '';

  const { saveTermsOfUse, saving } = usePostTermsOfUse(authType);
  const accept = Form.useWatch('accept-termsUse', form);

  const handleDeny = useCallback(() => {
    setNotAccept((pre) => !pre);
  }, []);

  const onCancel = useCallback(() => {
    setNotAccept(false);
  }, []);

  if (!data) {
    return (
      <ErrorFallback
        actionText="Go back to home page"
        errorText="Page not found"
        actionHandler={() => {
          window.location.pathname = '';
        }}
      />
    );
  }

  const onConfirm = async () => {
    try {
      await saveTermsOfUse(
        { version_id: data?.versionId, type: data?.type },
        {
          onSuccess() {
            sessionStorage.setItem('IntgratorsTerms', 'true');
          },
          onError() {
            message.error('error accepting Termsofuse');
          },
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div className="terms-container">
        <img id="nightOwl_logo" src={NightOwlLogo} alt="" className="terms-logo" />
        <div className="terms-use-box">
          <div className="terms-use-header">
            <h2 className="terms-title">{t('auth.terms-of-use.title')}</h2>
          </div>
          <PDFViewer file={data?.s3Url} />
          {notAccept && <TermsOfUseSupport closeModal={onCancel} />}
          {ToUAccepted === 'true' && (
            <Modal
              destroyOnClose={true}
              className="termsmodal"
              maskClosable={false}
              open={true}
              title={t('auth.terms-of-use.partners-accept')}
              centered
              closable={false}
              footer={null}>
              <div className="termsmodal">
                <div>{t('auth.terms-of-use.terme-use-close')}</div>
              </div>
            </Modal>
          )}
          {ToUAccepted !== 'true' && (
            <Form
              form={form}
              layout="vertical"
              requiredMark={false}
              name="activate"
              initialValues={{ accept: true }}
              onFinish={onConfirm}
              autoComplete="off">
              <Form.Item name="accept-termsUse" valuePropName="checked">
                <Checkbox className="accept-terms">{t('auth.terms-of-use.accept-terms')}</Checkbox>
              </Form.Item>
              <div className="buttons-container">
                <Button
                  id="terms_confirm"
                  disabled={!accept}
                  loading={saving}
                  type="primary"
                  htmlType="submit">
                  {t('auth.terms-of-use.accept')}
                </Button>
                <Button
                  id="terms_not_confirm"
                  className="button-default"
                  onClick={handleDeny}
                  type="default"
                  htmlType="button">
                  {t('auth.terms-of-use.not-accept')}
                </Button>
              </div>
            </Form>
          )}
        </div>
      </div>
    </>
  );
};

export default TermsOfUseIntegrators;
